import { useNavigate, useParams } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import EditWebhookForm from "../../../components/apps/webhooks/EditWebhookForm";

export default function EditWebhook() {
    const navigate = useNavigate();
    const { webhookId } = useParams();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/webhooks`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Editar Webhook"
                description="Editar webhook"
            />
            <PageBreadcrumb
                pageTitle="Editar Webhook"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <EditWebhookForm
                    webhookId={webhookId}
                    onSuccess={() => {
                        // Redirecionar para a página de listagem de webhooks
                        navigate(`/apps/webhooks`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao atualizar webhook:", error);
                    }}
                />
            </div>
        </>
    );
}